import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ContributorProfileEditModel } from 'src/app/photographer/models/contributor.profile.edit.model';

@Injectable()
export class PhotographerProfileService {

  constructor(private http: HttpClient) { }

  getProfile = (): Observable<ContributorProfileEditModel> =>
    this.http.get<ContributorProfileEditModel>(`${environment.apiUrl}/api/photographer/profile`)


  updateProfile = (model: ContributorProfileEditModel) =>
    this.http.post(`${environment.apiUrl}/api/photographer/profile`, model)

  getStripeAccountErrors = (id: string) =>
    this.http.get(`${environment.apiUrl}/api/photographer/profile/stripe-account-error/${id}`)

  refreshContributorStripeAccountStatus = (id: string): Observable<number> =>
    this.http.get<number>(`${environment.apiUrl}/api/photographer/profile/refresh-stripe-account-status/${id}`)
}
